module.exports = __webpack_public_path__ + "1bd6517874ddc6915908e2177e882dd9.svg";